import { render, staticRenderFns } from "./AdCard.ts.vue?vue&type=template&id=d28ce042"
import script from "./AdCard.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdCard.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AdCard.ts.vue?vue&type=style&index=0&id=d28ce042&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports